module.exports = __webpack_public_path__ + "static/media/fall.tar.dea9a2f5.gz";